export default "__VITE_ASSET__YRFvd8pB__"